query settings($filter: SettingFilterInput) {
  base {
    settings(filter: $filter) {
      items {
        id
        config
        value
      }
    }
  }
}
